










































































































































































































































































































































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";

import MapUI from "@/components/map/MapUI.vue";
import ControlsUI from "@/components/map/ControlsUI.vue";
import ScaleCoordinateUI from "@/components/map/ScaleCoordinateUI.vue";
import LegendUI from "@/components/map/LegendUI.vue";
import TreeListUI from "@/components/shared/TreeListUI.vue";
import WindowUI from "@/components/shared/WindowUI.vue";
import DialogUI from "@/components/shared/DialogUI.vue";
import EcoPlantBase from "./ecoplant.base";

import Map from "@/components/map/Map";
import { IMapLayer, IMapViewInfo, IMapAction, 
         Extent, IMapLayerSource } from "@/components/map/types";
import { EUserGroup, IIconMenu } from "@/components/shared/types";
import { User } from "@/components/User";

type EDrawerHelperPage = "" | "help";
type ETocOptions = "SEARCH" | "LAYERS" | "DOWNLOAD" | null;
const HELP_MENU:IIconMenu = {
  title: 'help',
  icon: 'picture_as_pdf',
  url: '/static/docs/Rice_User_Manual.pdf'
};

@Component({
  components: {
    'ol-map': MapUI,
    'ol-controls': ControlsUI,
    'ol-scale-coordinate': ScaleCoordinateUI,
    'v-legend': LegendUI,
    'v-tree-list': TreeListUI,
    'v-window': WindowUI,
    'v-dialog': DialogUI
  }
})
export default class Rice extends EcoPlantBase {
  DrawerHeight: number = 0;
  
  AdminTabs: string = "USERS";
  timeNow: string = null;
  clockInterval: NodeJS.Timer = null;

  showDrawerLeft: boolean = true;
  showDrawerLeftLast: boolean = true;
  showDrawerRight: boolean = false;
  showDrawerRight2: boolean = false;
  showDrawerMiniToolbar: boolean = true;
  DrawerHelperPage: EDrawerHelperPage = 'help'; // important since we use .math() for v-if
  DrawerHelperTitle: string = null;
  DrawerHelperSubTitle: string | string[] = null;
  DrawerHelperFile: string = '/static/docs/GISagro-1.0.pdf';
  DrawerHelperAvatar: string = null;
  DrawerHelperIcon: string = null;
  
  menuHelp: IIconMenu = HELP_MENU;

  // lifecycle methods
  created() {
    window.addEventListener('beforeunload', this.clearOpener);
    this.activeBaseMap = 'osm.cycle';
    this.topic = "RICE";
    this.fetchProvinces();
    this.fetchRidAreas();
    this.fetchPageView('rice');
  };

  mounted() {
    this.DrawerHeight = window.innerHeight - 76;
    this.clockInterval = setInterval(() => {
      let d = new Date();
      let hh = ('0' + d.getHours()).slice(-2);
      let mm = ('0' + d.getMinutes()).slice(-2);
      let ss = ('0' + d.getSeconds()).slice(-2);
      let yy = d.getFullYear() + 543;
      let MM = ('0' + (d.getMonth() + 1)).slice(-2);
      let dd = ('0' + d.getDate()).slice(-2); 
      this.timeNow = dd + '-' + MM + '-' + yy + ' ' + hh + ':' + mm + ':' + ss;
    }, 1000);
  };

  beforeDestroy() {
    clearInterval(this.clockInterval);
  };

  async onMapCreated(map:Map) {
    // map is a full component from olMap, including the native olMap
    // BaseMaps, active action, ... and all methods to call
    this.$map = map; // the same as this.$refs.map
    await this.getMapLayerStore();
    this.$map.createOverlayLayersAndControls(this.mapLayersReversed);
    this.mapLayers = this.mapLayersOrdered;
  };

  onOpenBasemap(open:boolean) {
    this.BaseMapListIsOpen = open;
  }

  /**
   * viewInfo: IMapViewInfo
   */
  onViewChange(viewInfo: IMapViewInfo) {
  };

  doMenuAction(menu:IIconMenu) {
    this.DrawerHelperTitle = menu.title;
    if (menu.icon) {
      this.DrawerHelperIcon = menu.icon;
      this.DrawerHelperAvatar = null;
    } else {
      this.DrawerHelperIcon = null;
      this.DrawerHelperAvatar = this.User.Avatar;
    }
    this.showDrawerLeftLast = this.showDrawerLeft;
    this.showDrawerLeft = false;
    this.showDrawerRight = false;
    setTimeout(() => {
      this.showDrawerRight2 = true;
      this.doHelperTool(menu);
    }, 0); // give time to close the right most sidedrawer
  };

  doHelperTool(menu:IIconMenu) {
    switch (menu.title) {
    case 'help':
      this.DrawerHelperFile = menu.url;
      this.DrawerHelperPage = 'help';
      this.DrawerHelperSubTitle = '';
      break;
    }
  };

  // toc for search or land info
  toggleToc(toc) {
    if (toc != this.toc) {
      this.toc = toc;
      if (this.toc=='DOWNLOAD') {
        this.getDownloadLists();
      }
    }
    this.showDrawerLeft = true;
  };

  setLayervisibility(mapSources:IMapLayerSource[], visibility) {
    mapSources.forEach((ms) => {
      if (ms.nativeLayer) {
        ms.nativeLayer.setVisible(visibility);
      }
    });
  }

  XdoMapLayerAction(data) {
    // data: {item:IMapLayer,action:{}}
    let item:IMapLayer = data.item;
    let action: any = data.action;
    if (action.action=='changeChecked') {
      if (item.type=='checkbox') {
        if (item.mapSources) {
          item.visible = !!item.checked;
          this.setLayervisibility(item.mapSources, item.checked);
        }
      } else if (item.type=='radio') {
        let cropLayer;
        this.mapLayerStore[0].children.forEach((child) => {
          if (child.mapSources[0].nativeLayer) {
            cropLayer = child.mapSources[0].nativeLayer;
          }
          if (child != item) {
            child.checked = false;
            child.visible = false;
            child.mapSources[0].visible = false;
          }
        });
        item.visible = !!item.checked;
        item.mapSources[0].visible = !!item.checked;
        if (cropLayer) {
          cropLayer.getSource().updateParams(item.mapSources[0].params);
          cropLayer.setVisible(false);
          cropLayer.setVisible(item.visible);
        }
      }
    }
  };
  
}
